import gql from 'graphql-tag';

import clientWorkspaceLeadFragment from './client-workspace-lead-fragment';

const updateByIdClientWorkspaceLeadMutation = gql`
  ${clientWorkspaceLeadFragment}
  mutation updateByIdClientWorkspaceLeadMutation($_id: MongoID!, $record: UpdateByIdClientWorkspaceLeadInput!) {
    updateByIdClientWorkspaceLeadMutation(_id: $_id, record: $record) { record { ...ClientWorkspaceLeadFragment } }
  }
`;
export default updateByIdClientWorkspaceLeadMutation;
